<template>
  <div class="animated fadeIn">

      <b-col lg="12">
        <c-table :table-data="items" :fields="fields" caption="Data"></c-table>
      </b-col>
  </div>

</template>
<script>
import { shuffleArray } from '@/shared/utils'
import cTable from './Table.vue'
import { async } from 'q'
import { setTimeout } from 'timers'
import numeral from 'numeral'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  name: 'tables',
  props: ['renderData','selectedSites', 'selectedServices'],
  components: {cTable},
  data: () => {
    return {
      chartData: [],
      tableData: [],
      items: [],
      fields: [
        {key: 'date', label: 'Date', sortable: true},
        {key: 'site', label: 'Site',sortable: true},
        {key: 'service'},
        {key: 'platform'},
        {key: 'revenue', sortable: true},
        {key: 'ad_request', sortable: true},
        {key: 'impression', sortable: true},
        {key: 'ctr', sortable: true},
        {key: 'ecpm', sortable: true},
      ],
      backgroundColor: '#16a085',
      
    }
  },
  /* async mounted() {
    setTimeout(() => {
      this.changeTableData()
    },2000)
  }, */
  watch: {
    renderData(newData, oldData){
      this.changeTableData();
    },
    selectedSites(newData,oldData){
      this.changeTableData()
    },
    selectedServices(newData,oldData){
      this.changeTableData()
    }
  },
  methods: {
    setItem(data,site){
      let impressions, ad_requests
      if(data.ecpms){
        for(let i = 0; i < data.ecpms.length; i++){
          if(data.impressions[i]> 100){
            impressions = parseFloat((data.impressions[i] / data.ad_requests[i]) * 100).toFixed(2)
          }
          else{
            impressions=data.impressions[i]
          }
        impressions = numeral(impressions)
        impressions = impressions.format().replace(/,/g, '.') + '%'
        ad_requests = numeral(data.ad_requests[i].toFixed(2))
        ad_requests = ad_requests._value
        this.selectedServices.forEach(element => {
          
          if(element===data.services[i]){
            this.tableData.push( {date: data.revenues.date[i],site:site,service:data.services[i],
            platform:data.platforms[i],revenue:data.revenues.revenueTypes[i]+ ' ' +data.revenues.value[i].toFixed(2),
            ad_request:ad_requests,impression:impressions,ctr:data.ctrs[i].toFixed(5),
            ecpm:data.ecpms[i].toFixed(2)})
          }
        });
        }
      }
    },
    async changeTableData(){
      this.tableData=[]
      if(this.$store.state.request){
        if(this.$store.state.itemsData.datas){
          if(this.$store.state.itemsData.datas[0]){
            this.chartData = await this.$store.state.itemsData.datas[0];
            numeral.defaultFormat('0,0');
            this.selectedSites.forEach( async element => {
              if(element==="onedioru"){
                await this.setItem(this.chartData.onedioruDatas,"onedio.ru")
              }
              else if(element==="onedioco"){
                await this.setItem(this.chartData.onediocoDatas,"onedio.co")
              }
              else if(element==="onediocom"){
                await this.setItem(this.chartData.onediocomDatas,"onedio.com")
              }
            });      
          }
        }
      if(this.tableData){
        await this.tableData.sort(this.date_sort).reverse()
      }
      this.items = this.tableData;
      }
    },
     date_sort(a, b) {
    return new Date(a.date).getTime() - new Date(b.date).getTime();
}
  },
}
</script>
<style <style lang="scss" scoped>
#table {
	margin: 0 auto;
	width: 500px;
	.input-group-text {
		padding: 0 .5em 0 .5em;
		
		.fa {
			font-size: 12px;
		}
	};
  background-color: aqua
  
}
</style>
